var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 23,
    viewBox: "0 0 36 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "dkmdb",
    width: 46,
    height: 33,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAhCAYAAACm75niAAAAAXNSR0IArs4c6QAAAjRJREFUWEftlz9uE0EUh79nr4k3MYptImFpXRiBhERDKFAKCpKKFskVVXA4AKlok5yAcAAUjgAnIDfAN8BFrBgcyYmESIz/DBpjh2DNencIMYzIa7bZ35tvf/vemxnB0RBHubkEn/af+/8cb1HKdukujpz28Ko5aoeTnG/tlLLpM5oTralM1oTls3J8n0LJI/lc4LGCkiFpFeSdh7c9+ogBbL+7jqhVzJqaCG8VvVd+pVGLW3KxwZsUN0FtxEysnd+aew0JYUNBNpZOyZb/bG8zzruR4D9KovMeOC2LOIlTxQ7+C+hnUnFeP31HoHosqZWoEooEbxJ8sIX28h3mHx0gs/Dt7sJvwafX6vcmffFE8CbBS2DdxjK50idf/oR+DsJL0F66jvISNmkgomxCwYeN+NFuNbj6oMXMra+/yHqFWTq3c7apQHo3who2FPyAYEfBU5vVkpkeuXLDKGkvFVDppE06EN74lXrFJAoFbxK0iDsNhpn9O1+Yu39khOvenKdbzFiBCxym1+rGX2UE/0ywKKCb0ip0Q6YKbaOmn50ZNKp1hJSLEbxJcRmUHoFWkS83SGR6Ro0uE10u1iGy4lf2dsd1fxR8YbU+kevkYWDNzTTArz3Z/zkGxxCn4rizNa7NcnKqaHBn57izO+ewXP7aWUWEbdWXo7Bj7j99OjzeKS6bZrg2NRLc2fP4aBw7dwM6u484eecc36uduuXbHzQuThHZnBe39PkyX4Kfzz97tbOOfwcDXwIxKWI7/QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "dkmda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 28a5 5 0 0 1-5-5V0a5 5 0 0 1 5-5h36a5 5 0 0 1 5 5v23a5 5 0 0 1-5 5z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(\"#dkmda\")"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(-5 -5)",
    xlinkHref: "#dkmdb"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.a98625ca700ed2194737f5ffdded0a49.svg";
export { ForwardRef as ReactComponent };